<template>
  <div class="flex items-center gap-0.5" :class="className">
    <UIcon
      v-for="star in 5"
      :key="star"
      :name="star <= rating ? 'i-heroicons-star-solid' : 'i-heroicons-star'"
      :class="[
        'text-base',
        star <= rating 
          ? 'text-yellow-400' 
          : 'text-gray-300 dark:text-gray-600'
      ]"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  rating: number
  className?: string
}

withDefaults(defineProps<Props>(), {
  className: ''
})
</script>
